module.exports = __webpack_public_path__ + "static/media/hear_results_2_mobile.9e8f71c7.jpg";